import React, { useContext } from 'react'

import { StyleSettings } from '../../generated/scheduler/graphql'

export const defaultThemeSettings: StyleSettings = {
  logoUrl: '',
  navbarColor: '#3F51B5',
  primaryColor: '#3F51B5' // indigo blue
}

export const ThemeContext = React.createContext<StyleSettings>(defaultThemeSettings)

const useTheme = () => useContext(ThemeContext)!

export default useTheme
